export const GA_MEASUREMENT_ID = 'G-Z5PKV57WML';

export interface GtagEventParams {
  [key: string]: string | number | boolean | undefined;
}

export type GtagCommand = 'config' | 'event' | 'js' | 'set';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (
      command: GtagCommand,
      targetId: string | Date,
      config?: GtagEventParams
    ) => void;
  }
}
